import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import draftToHtml from "draftjs-to-html";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import { DEVELOPMENT_TYPE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  fetchFeature,
  updateSortedFeatures,
  checkContentDashboardStatus,
} from "GeneralTabAction";
import { openFeaturesModal, contentAddRemoveModal } from "ContentActions";
import { insertWebview } from "ActionsWebview";
import { isEmpty } from "BaseFunctions";

import Exhibitors from "Exhibitors";
import Speakers from "Speakers";
import Sponsors from "Sponsors";
import Schedules from "Schedules";
import Maps from "Maps";
import Messages from "Messages";
import Social from "ContentSocial";
import News from "ContentNews";
import About from "ContentAbout";
import WebView from "ContentWebView";
import Gallery from "ContentGallery";
import Polls from "ContentPoll";
import Community from "ContentCommunity";
import Survey from "ContentSurvey";
import Gamification from "ContentGamification";
import Attendee from "ContentAttendee";
import Advertisement from "ContentAdvertisement";
import ContentFeatureItem from "./components/common/content-feature-item";
import AddNewFeature from "./add-new-feature";
import ShowHideFeature from "./show-hide-fetures";
import LocaleStrings from "Languages";

// userd for sort content list
const SortableItem = SortableElement(({ value, sortIndex }) => (
  <ContentFeatureItem feature={value} />
));

const SortableList = SortableContainer(({ items }) => {
  // console.log('items:  ', items);
  return (
    <ul className="list-group">
      {items.map((value, index) => {
        if (value.isenabled && value.taborder !== 99) {
          return (
            <SortableItem
              key={`item-${value.apptabid}`}
              index={index}
              value={value}
            />
          );
        }
      })}
    </ul>
  );
});

class Content extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //Handling redirections of content current and previous selections
    if (!isEmpty(this.props.selectedContentFeature)) {
      var path = _.lowerCase(this.props.selectedContentFeature.bsClass);
      var available = this.contentAvailable(
        this.props.selectedContentFeature.bsClass
      );
      if (available) {
        this.props.history.push(`/dashboard/content/${path}`);
      }
      if (
        path === "polls" ||
        path === "advertisement" ||
        path === "gamification"
      ) {
        this.props.history.push(`/dashboard/content/${path}`);
      }
    } else if (this.props.location.pathname === "/dashboard/content") {
      if (this.contentAvailable("schedule"))
        this.props.history.push("/dashboard/content/schedule");
    }

    this.props.fetchFeature(this.props.session);
    this.props.checkContentDashboardStatus(this.props.session);
  }

  openModal = () => {
    this.props.contentAddRemoveModal({ showModal: true });
  };

  // renderFeatureList(){
  //   return this.props.availableFeatures.map( (feature, index) =>{
  //       // var item = _.find(this.props.selectedFeatures, {isenabled:true});
  //       if(feature.isenabled) {
  //         return(<ContentFeatureItem key={feature.bsClass} feature={feature}/>);
  //       }
  //   });
  // }

  // renderMenuList(){
  //   return this.props.actionAppModules.map( (app, index) =>{
  //     if(app.isenabled && app.bsClass == 'polls') {
  //       return(<ContentFeatureItem key={app.bsClass} feature={app}/>);
  //     }
  //   });
  // }

  renderFixedMenuList() {
    return this.props.fixedFeatures.map((app, index) => {
      return <ContentFeatureItem key={app.bsClass} feature={app} />;
    });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    // var arrAvailable = this.props.availableFeatures;
    var arrAvailable = _.filter(this.props.mergerArray, (obj) => {
      return obj.taborder !== 99;
    });

    // console.log('arrAvailable before :- ', arrAvailable);
    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);

    // console.log('arrAvailable after :- ', arrAvailable);
    var newArrAvailable = [];

    //Just map the array and reset the taborder as now taborder is same as the object position
    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, taborder: index + 1 });
    });

    // console.log('newArrAvailable :- ', newArrAvailable);

    /*if(oldIndex < newIndex) {
      var temp = arrAvailable[oldIndex];

      for ( var i = oldIndex; i < newIndex; i++) {
        arrAvailable[i] = arrAvailable[i+1];
        arrAvailable[i].taborder = arrAvailable[i].taborder-1;
      }
      arrAvailable[newIndex] = temp;
      arrAvailable[newIndex].taborder = newIndex+1;
    }
    else {
      var temp = arrAvailable[oldIndex];
      for ( var i = oldIndex; i > newIndex; i--) {
        arrAvailable[i] = arrAvailable[i-1];
        arrAvailable[i].taborder = arrAvailable[i].taborder+1;
      }
      arrAvailable[newIndex] = temp;
      arrAvailable[newIndex].taborder = newIndex+1;
    }*/

    this.props.updateSortedFeatures(newArrAvailable, this.props.session);
  };

  contentAvailable(content) {
    var existingFeature = this.props.selectedFeatures.filter(
      (feature) => feature.bsClass === content && feature.isenabled
    );
    return existingFeature.length > 0;
  }

  onManageFeatures = () => {
    this.props.openFeaturesModal(true);
  };

  submitWebviewDataHandler = (values, webview, webprops) => {
    // debugger;
    var data;
    if (values.htmlcontent && values.htmlcontent.blocks) {
      var html = draftToHtml(values.htmlcontent);
      html = html.replace(/[\n\r]+/g, "");
      if (html == "<p></p>") html = "";
      data = { ...values, htmlcontent: html };
    } else data = { ...values };

    this.props.insertWebview(this.props.session, data, webview, (result) => {
      webprops.stopSubmit("WebViewForm");
      if (result.error === 1) {
        this.props.showError("Something is wrong");
      } else {
        this.props.showSuccess("Webview updated successfully");
        this.callContentBoardStatus();
      }
    });
  };

  callContentBoardStatus = () => {
    this.props.checkContentDashboardStatus(this.props.session);
  };

  render() {
    let {
      contentAddRemoveModalStatus,
      availableFeatures,
      actionAppModules,
      mergerArray,
    } = this.props;
    // console.log("mergerArray: ", mergerArray);
    let hrstyle = {
      marginLeft: -16,
      marginRight: -16,
      borderTop: "1px solid #e6edf3",
    };
    // console.log('contentAddRemoveModalStatus :- ', contentAddRemoveModalStatus)

    return (
      <div>
        <div className="content-parent-container">
          <div className="content-submenu vertical-line">
            {/* This below section is commented, its not required now, if in future it requirs need to add current logic to display conten (i.e by isenabled key) */}

            {/* <div className="content-feature-title">
            <div className="row">
              <div className="col-md-9" style={{paddingLeft:8,paddingRight:9}}>App Features</div>
              <div className="col-md-3" style={{paddingLeft:0}}>
                  <OverlayTrigger
                  key='manage'
                  placement='right'
                  overlay={
                    <Tooltip id='tooltip-manage'>
                      Cilck to Manage Features
                    </Tooltip>
                  }
                  >
                  <img src={NEW_IMAGE_PATH + 'settings.png'} className="app-features-settings-icon" onClick={this.onManageFeatures}/>
                </OverlayTrigger>
              </div>
                <AddNewFeature/>
            </div>
          </div> */}

            <div
              style={{
                backfaceVisibility: "hidden",
                willChange: "transform",
                userSelect: "none",
                WebkitUserSelect: "none",
                titleBarStyle: "hidden",
              }}
            >
              {/* userd for sort content list  */}
              {/* lockToContainerEdges= true, lockAxis= 'y', , transitionDuration= 0, distance= 1 */}
              <SortableList
                useDragHandle
                items={mergerArray.length > 0 ? mergerArray : []}
                // onSortEnd={this.onSortEnd}
                //pressDelay={200}
                lockAxis="y"
              />

              {DEVELOPMENT_TYPE === "koachify" ? (
                <button
                  type="button"
                  className="btn btn-custom-blue w-100"
                  onClick={this.openModal}
                >
                  {LocaleStrings.button_add_remove_content}
                </button>
              ) : (
                ""
              )}

              {mergerArray.length > 0 && DEVELOPMENT_TYPE === "eventify" ? (
                <hr style={hrstyle} />
              ) : (
                ""
              )}

              <ul className="list-group">{this.renderFixedMenuList()}</ul>

              <ul className="list-group">
                {/* {this.renderFeatureList()}
                {this.renderMenuList()} */}

                {/* <li className="list-group-item content-features-li blank-li"></li>
                <li className="list-group-item content-features-li add-new-feature-button">
                  <AddNewFeature
                    availableFeatures={this.props.availableFeatures}
                    selectedFeatures={this.props.selectedFeatures}
                  />
                </li> */}
              </ul>

              {contentAddRemoveModalStatus &&
              contentAddRemoveModalStatus.showModal ? (
                <ShowHideFeature history={this.props.history} />
              ) : (
                ""
              )}
            </div>
          </div>
          <div
            className="content-subcontainer"
            // style={{ width: `${contentContainerWidth}px` }}
          >
            <Route
              path="/dashboard/content/exhibitor"
              history={this.props.history}
              component={Exhibitors}
            />
            <Route
              path="/dashboard/content/speaker"
              history={this.props.history}
              component={Speakers}
            />
            <Route
              path="/dashboard/content/sponsor"
              history={this.props.history}
              component={Sponsors}
            />
            <Route
              path="/dashboard/content/schedule"
              render={(props) => (
                <Schedules
                  contentBoardStatus={this.callContentBoardStatus}
                  history={this.props.history}
                />
              )}
            />
            <Route
              path="/dashboard/content/maps"
              history={this.props.history}
              component={Maps}
            />
            <Route
              path="/dashboard/content/message"
              history={this.props.history}
              component={Messages}
            />
            <Route
              path="/dashboard/content/news"
              history={this.props.history}
              component={News}
            />
            <Route
              path="/dashboard/content/about"
              render={(props) => (
                <About
                  contentBoardStatus={this.callContentBoardStatus}
                  history={this.props.history}
                />
              )}
            />
            <Route
              path="/dashboard/content/social"
              history={this.props.history}
              component={Social}
            />
            <Route
              path="/dashboard/content/webview"
              render={(props) => (
                <WebView
                  submitWebviewDataHandler={this.submitWebviewDataHandler}
                />
              )}
            />
            <Route
              path="/dashboard/content/gallery"
              render={(props) => (
                <Gallery
                  contentBoardStatus={this.callContentBoardStatus}
                  history={this.props.history}
                />
              )}
            />
            {/* <Route path="/dashboard/content/polls" component={Polls} /> */}
            <Route
              path="/dashboard/content/community"
              render={(props) => (
                <Community
                  contentBoardStatus={this.callContentBoardStatus}
                  history={this.props.history}
                />
              )}
            />
            <Route
              path="/dashboard/content/survey"
              render={(props) => (
                <Survey
                  contentBoardStatus={this.callContentBoardStatus}
                  history={this.props.history}
                />
              )}
            />
            <Route
              path="/dashboard/content/gamification"
              component={Gamification}
              history={this.props.history}
            />
            <Route path="/dashboard/content/attendee" component={Attendee} />
            <Route
              path="/dashboard/content/advertisement"
              component={Advertisement}
              history={this.props.history}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('state.contentDashboard :- ', state.contentDashboard.data)
  // console.log('state.actionAppModules :- ', state.actionAppModules)
  // console.log('state.contentAddRemoveModal :- ', state.contentAddRemoveModal)
  // console.log("state.selectedContentFeature :- ", state.selectedContentFeature);

  return {
    availableFeatures: state.availableFeatures.filter(
      (feature) => feature.available
    ),
    session: state.session,
    selectedFeatures: state.selectedFeatures,
    selectedContentFeature: state.selectedContentFeature,
    contentDashboard: state.contentDashboard.data,
    totalAppModules: state.totalAppModules,
    actionAppModules: state.actionAppModules,
    mergerArray: state.contentDisplayItems,
    fixedFeatures: state.fixedFeatures,
    contentAddRemoveModalStatus: state.contentAddRemoveModal,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  insertWebview,
  fetchFeature,
  openFeaturesModal,
  updateSortedFeatures,
  checkContentDashboardStatus,
  contentAddRemoveModal,
})(Content);
